import type { BoxProps, SxProps, Theme } from "@mui/material";
import { Box } from "@mui/material";
import type { PropsWithChildren, Ref, UIEvent } from "react";

interface Props extends Omit<BoxProps, "ref"> {
  ref?: Ref<HTMLDivElement>;
  scrollContainerSx?: SxProps<Theme>;
  containerRef?: Ref<HTMLDivElement>;
  onScroll?: (e: UIEvent<HTMLDivElement>) => void;
}

const ScrollableFlexContainer = ({
  scrollContainerSx,
  onScroll,
  children,
  containerRef,
  ...props
}: PropsWithChildren<Props>) => {
  return (
    <Box {...props} sx={{ flex: 1, position: "relative", width: "100%", ...props.sx }}>
      <Box
        ref={containerRef}
        onScroll={onScroll}
        sx={{ position: "absolute", height: "100%", width: "100%", overflowY: "auto", ...scrollContainerSx }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default ScrollableFlexContainer;
